module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAAAXNSR0IArs4c6QAAANBJREFUSEu1lSEOAjEQRd8IHBpuiMBgEEAIYhUhaAQ34GYEjSNkyCQjmpC223Zbv/P6X/p3hMKjqntgA9yBi4i8UyOkcD6q+gSWgAI3YBCRV2xODWAAjoB9+/Eku1iSGsAcOAMrYOZJrp7kT1cxwFSo6gI4AWtPEtVVBXCIJTHINqWrGhBAkrqaAGN0NQOyurw4B8CcTn0eEhRn6uE272sAq36/BFNcW1XjT7YVkCtd0yvym/fpQVJL8AuvSpDTEmovBozR0grovg+6b7SinfwDF5mIa9uZ3UsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/youjianto-bai.png
// module id = m+8V
// module chunks = 1